import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="lightest" className="titleBlock-align-left pb-0 take-your-project-cta" mdxType="TitleBlock" />
    <h2 {...{
      "id": "take-your-project-to-the-next-level"
    }}>{`Take your project to the next level.`}</h2>
    <TextBlock slots="text" theme="lightest" width="100%" className="padding-top-zero-child margin-zero padding-bottom-child" mdxType="TextBlock" />
    <p>{`Build it. Test it. Deliver it. Do it all faster and easier than ever with Acrobat Sign APIs. Discover
what sets Acrobat Sign apart.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      